export class FeatureOptionModel{
    option:any[]
    constructor(option:any[]){
        this.option = option
    }
}